import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const paypal = defineConnector({
  identifier: "paypal",
  name: "PayPal",
  tagLine: "Online payments platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api(-m)?(\\.sandbox)?\\.paypal\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [PayPal Developer Dashboard](https://developer.paypal.com/dashboard/applications/live), select your app, and copy the client ID and secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api-m.paypal.com/v1/oauth2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api-m.paypal.com/v1/catalogs/products?page_size=1",
  },
});
